import { ButtonBase } from '@mui/material';
import { UseDateFieldProps } from '@mui/x-date-pickers/DateField';
import { BaseSingleInputFieldProps, DateValidationError, FieldSection } from '@mui/x-date-pickers/models';
import { DateTime } from 'luxon';
import { InputBaseWrapper } from '../TextInput/TextInputStyle';

interface ButtonFieldProps
  extends UseDateFieldProps<DateTime>,
    BaseSingleInputFieldProps<DateTime | null, DateTime, FieldSection, DateValidationError> {
  error?: boolean;
  placeholder?: string;
  onClick?: () => void;
}

function ButtonField({ value, error, placeholder, onClick, InputProps: { ref } = {} }: ButtonFieldProps) {
  return (
    <ButtonBase
      onClick={onClick}
      component="div"
      sx={{
        justifyContent: 'flex-start',
        cursor: 'pointer',
        '&:hover': {
          cursor: 'pointer',
        },
        caretColor: 'transparent',
        width: '100%',
      }}
      ref={ref}
      disableRipple
    >
      <InputBaseWrapper
        value={value ? value.toFormat('    dd    |    LL    |    y    ') : ''}
        placeholder={placeholder}
        error={error}
        readOnly
        inputProps={{
          readOnly: true,
          tabIndex: -1,
        }}
        sx={{
          textAlignLast: 'justify',
          cursor: 'pointer',
          '& .MuiInputBase-input': {
            cursor: 'pointer',
          },
          '& .MuiInputBase-root': {
            pointerEvents: 'none',
          },
          width: '100%',
        }}
      />
    </ButtonBase>
  );
}

export default ButtonField;
